export default __webpack_public_path__ + "static/media/none_rule.ecbd31bc.svg";